export default "__VITE_ASSET__dce9cbd1__"